<div class="main-wrap">
  <div class="component-wrapper">
    <div class="alert alert-warn text-sm w-100 mb-0 d-none"><strong>Limited functionality!&nbsp;</strong>PDF-plugin is not
      installed or
      disabled.
    </div>
    <div class="login-page">
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      <div class="logo"><img src="assets/img/filings_summary_logo.png"/></div>
      <div class="filing"><img src="assets/img/complete-filing-report-of.png"/></div>
      <form [formGroup]="loginForm" [class.error]="!loginForm.valid && loginForm.touched">
        <mat-card class="login-form dense-5">
          <span class="main-text-font title-signin">Login</span>
          <div *ngIf="error" class="alert alert-error"><strong>Failed to sign in!</strong> Please check your credentials
            and try again.
          </div>
          <div class="login-input-container flex-row">
            <mat-form-field class="w-100 h-100 styled" appearance="outline" subscriptSizing="dynamic">
              <input type="email" matInput name="username" formControlName="username" placeholder="Email">
            </mat-form-field>
            <mat-form-field class="w-100 h-100 styled" appearance="outline" subscriptSizing="dynamic">
              <input matInput type="password" name="password" formControlName="password" placeholder="Password">
            </mat-form-field>
            <button mat-stroked-button class="styled secondary" (click)="login()">Login
            </button>
          </div>
          <div class="flex-column-layout mt-2">
            <div class="flex-row mb-2">
              <span>
                <input type="checkbox"/>
              </span>
              <span class="main-text-font text-sm checkbox-text">Remember me</span>
            </div>
            <div class="forgot-password-cont mt-1">
            <span class="main-text-font main-links-color link-underscore element-hover text-sm"
                  routerLink="/forgotPassword">Forgot your password?</span>
            </div>
          </div>
        </mat-card>
      </form>
      <div class="bottom-logo"><img src="assets/img/dpc_logo.png"></div>
      <div class="flex-grow-1"></div>
    </div>
    <app-main-footer></app-main-footer>
  </div>
</div>
